import { useMutation, /*gql*/ } from "@apollo/client";
import { successNotification } from "../../../../result";


const useMutationEventUpdate = (mutation, exbnEvnt) => {

  const [ _setMutationVariableUpdate,
    { loading: loadingMutationUpdate,
      error: errorMutationUpdate, data } ] = useMutation(mutation,
        {
          update(_, { data }) {
            const {
              eeUpdate: {
                label,
                message,
              }
            } = data;

            successNotification({
              title: label.toUpperCase(),
              description: message
            });
          },
        });


  return {
    _setMutationVariableUpdate,
    loadingMutationUpdate,
    errorMutationUpdate,
    dataMutationUpdate: data && data.nameMutatiom
  }
};

export default useMutationEventUpdate;